import { Component, OnInit, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';

import { HttpClient } from '@angular/common/http';
import { environment } from '.../../environments/environment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { Observable, Subscription } from 'rxjs/Rx';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../_services/index';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { Broadcaster } from '.../../environments/broadcaster';
import { LoaderService } from '../../_services/loader.service';
import { reverse } from 'lodash';

import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
	parse: {
		dateInput: 'LL'
	},
	display: {
		dateInput: 'LL',
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY'
	}
};
declare var $: any;
declare var google: any;
declare var firebase: any;
declare var MapLabel: any;
var stopAnimation = true;

declare const MarkerClusterer;

@Component({
	selector: 'app-alarms',
	templateUrl: './alarms.component.html',
	styleUrls: ['./alarms.component.scss'],
	providers: [
		{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
		{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
	]
})
export class AlarmsComponent implements OnInit, OnDestroy {
	public polyline_array;
	routeAccuracy: any;
	multiRoute: any;
	assignWard: any;
	beatName: any;
	clickedMarker: any;
	IEMI: any;
	VEHNO: any;
	tempVehiclesData: any;
	mapLabelArray: any;
	public projectID: any;
	public project: any;
	public map: any;
	public projectMaster: any;
	public vehiclesData: any;
	public selectedlist: number;
	public vehiclesLocation: any;
	public vehiclesRoute: any;
	public search: any;
	public selectedProjectId: any;
	public PRJNAME: any;
	public polygondData: any;
	public prjID: any;
	public date = moment();
	public latlongs = [];
	countData: any;
	all: any;
	routePath: any;
	isLive: any;
	a = [];
	route: any;
	markerStart: any;
	markerEnd: any;
	vehiclesNo: any;
	IMEI: any;
	mobileNo: any;
	startTime: any;
	endTime: any;
	geocoder: any;
	currentAddress: any;
	Liveroute: any;
	distance: any;
	stopAnimation: any;
	allMarkers = [];
	autoTicks = false;
	disabled = false;
	invert = false;
	max = 1000;
	public value: any;
	min = 0;
	showTicks = false;
	step = 1;
	thumbLabel = false;
	position = [43, -89];
	vertical = false;
	counter: any;
	public icon: any;
	vechicleListIsClicked: any;
	servingWardName: any;
	servingBeat: any;
	stopSummary: any;
	totalStopBeat: any;
	wardBoundary: any;
	beatBoundary: any;
	routeBoundary;
	polygon: any;
	infoWindowStart: any;
	infoWindowEnd: any;
	vehicleCluster: any;
	markerCluster: any;
	isStats: any;
	showLoader: any;
	vehicleInfoWindow: any;
	vehicleInfoWindowClicked: any;

	lastActiveTime: any;
	currentAddressStart: any;
	areaAssignment: any;
	staffAssignment: any;
	authtoken: any;
	vehID: string;
	alarmList: any;
	assignZone: any;
	assignData: {};
	assignedCount: any;
	countAssigned: number;
	fetchZone: any;
	fetchWard: any;
	lastAlarm: any;
	lastAlarmTime: any;
	alarmSummary: any;
	alarmIMEI: any;
	alarmRCNO: any;
	totalAlarmGenerated: any;
	stop_info_data: any;
	longHault: number;
	countAlarmData: any;
	alarmType: any;
	driverName: any;
	driverRole: any;
	driverMob: any;
	singleVehSummary: any;
	longHaultStop: any;
	alarmTypeId: any;
	singleVehAlarmPoints: any;
	alarmTime: any;
	alarmDate: any;
	vehNO: any;
	startDate: any;
	endDate: any;
	defaultStartDate: any;
	defaultEndDate: any;
	dataRangeModal: any;
	singleVehUccData: any;
	vehUCC: any;
	alarmSummaryReverse: any;

	apiLat;
	apiLng;
	apiAddress;
	
	private subscription: Subscription;
	delayedAlarmData: any;
	onTimeCount: any;
	lateCount: any;

	constructor(
		private auth: AuthService,
		private http: HttpClient,
		private loaderService: LoaderService,
		private routes: ActivatedRoute,
		private broadcaster: Broadcaster,
		private router: Router,
		public datepipe: DatePipe
	) {
		this.authtoken = JSON.parse(localStorage.getItem('authData'));
		this.routeAccuracy = false;
		this.vehicleInfoWindow = new google.maps.InfoWindow();
		this.vehicleInfoWindowClicked = new google.maps.InfoWindow();
		this.value = 300;
		this.multiRoute = [];
		this.polyline_array = [];
		this.mapLabelArray = [];
		this.isStats = true;
		//this.vehicleCluster  = true
		this.prjID = this.auth.getAuthentication().projectId;
		var car =
			'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z';
		this.icon = {
			path: car,
			scale: 0.5,
			strokeColor: 'white',
			strokeWeight: 0.1,
			fillOpacity: 1,
			fillColor: '#404040',
			offset: '3%',
			// rotation: parseInt(heading[i]),
			anchor: new google.maps.Point(10, 25) // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
		};
		this.countAlarmData = {
			longHault: 0,
			delayed: 0,
			missed: 0,
			deviated: 0
		};

		this.loaderService.status.subscribe((val: boolean) => {
			this.showLoader = val;
		});

		var firstDay = new Date();
		var lastDay = new Date();
		this.defaultStartDate = firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
		this.defaultEndDate = firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
		this.dataRangeModal = {
			beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() },
			endDate: { year: lastDay.getFullYear(), month: lastDay.getMonth() + 1, day: lastDay.getDate() }
		};

		this.locate();
	}

	public locate() {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				position => {
					this.apiLat = position.coords.latitude;
					this.apiLng = position.coords.longitude;

					let geocoder = new google.maps.Geocoder();
					let latlng = new google.maps.LatLng(this.apiLat, this.apiLng);
					let request = {
						latLng: latlng
					};

					geocoder.geocode(request, (results, status) => {
						if (status == google.maps.GeocoderStatus.OK) {
							if (results[0] != null) {
								this.apiAddress = results[0].formatted_address;
								console.log(this.apiAddress);
							} else {
								alert("No address available");
							}
						}
					});
				},
				error => {
					console.log("Error code: " + error.code + "<br /> Error message: " + error.message);
				}
			);
		}
	}

	getDataWhenProjectChange = async (id) => {
		$('#loderImgTab').show();
		this.loaderService.display(true);
		this.renoveAllMarker();
		let polygon = await fetch(
			environment.apiUrl + 'entity/getPolygonByOemId' + '?prjid=' + id + '&wardOemId=null' + '&beatOemId=null',
			{
				method: 'get',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization: this.authtoken.token
				}
			}
		);
		this.polygondData = await polygon.json();
		this.clearFeature();
		this.map.data.addGeoJson(this.polygondData.geoJson);
		this.zoom(this.map, true);
		//this.setStyle(this);
		this.loaderService.display(false);

		$('.background').hide();
		$('#loderImgTab').hide();
		$('#progress-bar').hide();
	};

	getAlarmCount() {
		var countObj = {
			prjId: this.prjID
		};
		this.assignData = {};
		this.http.post(environment.apiUrl + 'getRouteAssignedVehicleCount', countObj).subscribe((data) => {
			this.assignedCount = data;
			console.log('Count', this.assignedCount);
			this.getAssignCount(data);
		});
	}

	getAssignCount(count) {
		this.countAssigned = count.assignedVehicles;
		console.log('assigned', this.countAssigned);
	}

	getTotalAlarmCount(countAlarm) {
		var longHault = 0;
		var deviated = 0;
		var missed = 0;
		var delayed = 0;

		for (var i = 0; i < countAlarm.length; i++) {
			if (countAlarm[i].alarmTypeId == 2) {
				longHault++;
			}

			if (countAlarm[i].alarmTypeId == 1) {
				deviated++;
			}
		}
		this.countAlarmData = {
			longHault: longHault,
			delayed: 0,
			missed: 0,
			deviated: deviated
		};

		console.log('Count Alarm', this.countAlarmData);
	}

	deleteMarker(id, mylatlongs, ANGLE) {
		if (this.allMarkers.length > 0) {
			for (var i = 0; i < this.allMarkers.length; i++) {
				if (this.allMarkers[i].id == id) {
					if (this.isLive) {
						var car =
							'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z';
						var icon = {
							path: car,
							scale: 0.7,
							strokeColor: 'white',
							strokeWeight: 0.11,
							fillOpacity: 1,
							fillColor: '#404040',
							offset: '4%',
							rotation: ANGLE //<-- Car angle
						};
						this.allMarkers[i].setIcon(icon);
						this.allMarkers[i].setVisible(true);
						this.allMarkers[i].setPosition(mylatlongs);
					}
				}
			}
		}
	}

	renoveAllMarker() {
		if (this.allMarkers.length > 0) {
			for (var i = 0; i < this.allMarkers.length; i++) {
				this.allMarkers[i].setVisible(false);
			}
		}
	}

	plotMarker(point, DEVICEID, DEVICEDATE) {
		var car =
			'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z';
		var lineSymbol = {
			path: car,
			scale: 0.7,
			strokeColor: 'white',
			strokeWeight: 0.1,
			fillOpacity: 1,
			fillColor: '#0B0104',
			offset: '5%',
			anchor: new google.maps.Point(10, 25) // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
		};
		this.markerStart = new google.maps.Marker({
			position: point,
			map: this.map,
			icon: lineSymbol,
			title: DEVICEID + '(' + DEVICEDATE + ')'
		});
		this.markerStart.id = DEVICEID;
		this.markerStart.setMap(this.map);
		this.allMarkers.push(this.markerStart);
	}

	processPoints(this, geometry, callback, thisArg) {
		if (geometry instanceof google.maps.LatLng) {
			callback.call(thisArg, geometry);
		} else if (geometry instanceof google.maps.Data.Point) {
			callback.call(thisArg, geometry.get());
		} else {
			if (geometry) {
				geometry.getArray().forEach((g) => {
					this.processPoints(g, callback, thisArg);
				});
			}
		}
	}

	zoom(this, map, isZone) {
		this.bounds = new google.maps.LatLngBounds();
		this.map.data.forEach((feature) => {
			if (isZone) {
				this.processPoints(feature.getGeometry(), this.bounds.extend, this.bounds);
			} else {
				if (feature.getProperty('type') == 'route') {
					this.processPoints(feature.getGeometry(), this.bounds.extend, this.bounds);
				}
			}
		});
		map.fitBounds(this.bounds);
	}

	dateChanged() {
		console.log('fsdjhfdskhfksdhfsdhf');
		this.getAlarm();
		this.getDelayed();
	}

	reload() {
		$('#loderImgTab').hide();
		$('#alarmtable1').hide();
		$('#play').show();
		$('#stop').hide();
		$('#veichiclesInfo-bar').hide();
		$('#progress-bar').hide();
		this.removeMultiRoute();
		this.removeLine();
		this.removeMarker();
		this.clearStopMarker();
		this.getDataWhenProjectChange(this.prjID);
		this.vechicleListIsClicked = false;
	}

	removeAssignRoute() {
		this.map.data.forEach((feature) => {
			// this.map.data.remove(feature);
			if (feature.getProperty('Oemid') != 7) {
				this.map.data.remove(feature);
			}
		});
	}

	getAssignroute(id) {
		this.removeAssignRoute();
		this.http.get(environment.apiUrl + 'entity/getVehicleroute?' + 'vehId=' + id).subscribe((data) => {
			console.log(data);
			var result: any;
			result = data;
			this.map.data.addGeoJson(result.geoJson);
		});
	}

	createPopupClass() {
		/**
     * A customized popup on the map.
     * @param {!google.maps.LatLng} position
     * @param {!Element} content The bubble div.
     * @constructor
     * @extends {google.maps.OverlayView}
     */
		function Popup(position, content) {
			this.position = position;

			content.classList.add('popup-bubble');

			// This zero-height div is positioned at the bottom of the bubble.
			var bubbleAnchor = document.createElement('div');
			bubbleAnchor.classList.add('popup-bubble-anchor');
			bubbleAnchor.appendChild(content);

			// This zero-height div is positioned at the bottom of the tip.
			this.containerDiv = document.createElement('div');
			this.containerDiv.classList.add('popup-container');
			this.containerDiv.appendChild(bubbleAnchor);

			// Optionally stop clicks, etc., from bubbling up to the map.
			google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv);
		}
		// ES5 magic to extend google.maps.OverlayView.
		Popup.prototype = Object.create(google.maps.OverlayView.prototype);

		/** Called when the popup is added to the map. */
		Popup.prototype.onAdd = function () {
			this.getPanes().floatPane.appendChild(this.containerDiv);
		};

		/** Called when the popup is removed from the map. */
		Popup.prototype.onRemove = function () {
			if (this.containerDiv.parentElement) {
				this.containerDiv.parentElement.removeChild(this.containerDiv);
			}
		};

		/** Called each frame when the popup needs to draw itself. */
		Popup.prototype.draw = function () {
			var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

			// Hide the popup when it is far out of view.
			var display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? 'block' : 'none';

			if (display === 'block') {
				this.containerDiv.style.left = divPosition.x + 'px';
				this.containerDiv.style.top = divPosition.y + 'px';
			}
			if (this.containerDiv.style.display !== display) {
				this.containerDiv.style.display = display;
			}
		};

		return Popup;
	}

	optimizeRoute() {
		if (this.routeAccuracy) {
			this.routeAccuracy = false;
		} else {
			this.routeAccuracy = true;
		}
	}

	getAlarm() {
		$('#loderImgTab').show();
		var dataObj = {
			prjId: this.prjID,
			date: moment(this.date).format('YYYY-MM-DD')
		};
		this.http.post(environment.apiUrl + 'getVehicleAlarms', dataObj).subscribe((data) => {
			this.alarmList = data;
			//console.log('List', this.alarmList);
			this.getTotalAlarmCount(data);
		});
		$('#loderImgTab').hide();
	}

	getDelayed() {
		$('#loderImgTab').show();
		var date = moment(this.date).format('YYYY-MM-DD')
		this.http.get(environment.apiUrl + 'vehicleAlarm/getVehDelayed?prjid=' + this.prjID + '&date=' + date).subscribe((data) => {
			this.delayedAlarmData = data;
			this.onTimeCount = this.delayedAlarmData.onTime.length
			this.lateCount = this.delayedAlarmData.late.length
		});
		$('#loderImgTab').hide();
	}

	downloadDelayed(){
		var date = moment(this.date).format('YYYY-MM-DD')
		window.open(environment.apiUrl + 'vehicleAlarm/downloadDelayed?prjid=' + this.prjID + '&date=' + date);
	}

	refreshCount(id) {
		$('#loderImgTab').show();
		var dataObj = {
			prjId: this.prjID,
			date: moment(this.date).format('YYYY-MM-DD')
		};
		this.http.post(environment.apiUrl + 'getVehicleAlarms', dataObj).subscribe((data) => {
			this.alarmList = data;
			//console.log('List', this.alarmList);
			this.getTotalAlarmCount(data);
		});
		$('#loderImgTab').hide();
		//console.log('refresh', this.alarmList);
	}

	getAlarmDetails = async (data, index) => {
		console.log('Get Details', data);
		this.Info_alarmModal_btn(data.vehId);
		this.vehID = data.vehId;
		this.alarmType = data.alarmType;
		this.alarmTypeId = data.alarmTypeId;
		this.lastAlarmTime = this.highLightAssignBeat(data.wardid);
		this.getAssignroute(data.vehId);
		this.loaderService.display(true);
		this.vechicleListIsClicked = true;
		this.IEMI = data.IMEI;
		this.VEHNO = data.vehno;
		this.mobileNo = data.vtsmobileno;
		this.servingWardName = '';
		this.assignWard = data.WardName;
		this.assignZone = data.zoneName;
		$('#alarmtable1').hide();
		console.log('veh', this.vehID);
		this.clearCurrentVehicalInfo();
		this.renoveAllMarker();
		let date = moment(this.date).format('YYYY-MM-DD');
		this.selectedlist = index;
		let response = await fetch(
			environment.apiUrl +
			'vehicles/route' +
			'?DEVICEID=' +
			data.IMEI +
			'&prjId=' +
			this.prjID +
			'&date=' +
			date +
			'&accuracy=' +
			this.routeAccuracy,
			{
				method: 'get',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization: this.authtoken.token
				}
			}
		);
		let result = await response.json();
		this.loaderService.display(false);
		if (result.status == 'No Route Found') {
			this.removeMarker();
			this.getPrevDayLocation(data);
			if (result.data.length > 0) {
				this.showCurrentVehiclesInfo(result.data[0], data);
				this.locateVehicle(result.data[0].STARTPOINT);
				this.plotStartAndEndPoint(result.data[0]);
				$('#alarmtable1').show();
			} else {
				this.removeMarker();
				$('#alarmtable1').hide();
			}
			$('#statusTable').show();
			$('#veichiclesInfo-bar').hide();
			this.clearStopMarker();
			this.removeMultiRoute();
			this.removeLine();
			alert(result.status);
		} else {
			$('#alarmtable1').show();
			this.removeLine();
			this.removeMultiRoute();
			this.createRoute(this.map, result.latLong);
			this.showCurrentVehiclesInfo(result, data);
			this.removeMarker();
			this.plotStartAndEndPoint(result);

			let stopInfo = await fetch(
				environment.apiUrl + 'getStopInfo?DEVICEID=' + data.IMEI + '&DEVICEDATE=' + date,
				{
					method: 'get',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
						Authorization: this.authtoken.token
					}
				}
			);
			this.stop_info_data = await stopInfo.json();
			// this.stop_info_data = reverse(this.stop_info_data);
			this.lastAlarm = this.stop_info_data.slice(-1)[0].beatName;
			console.log('Last Stop', this.stop_info_data);

			this.singleVehAlarmPoints = this.alarmList.filter(
				(item) => item.IMEI == this.IMEI && item.alarmTypeId == this.alarmTypeId // 1
			);

			this.alarmSummaryReverse = reverse(this.singleVehAlarmPoints);
			console.log('AlarmPoints', this.alarmSummaryReverse);

			 

		 // var testing = 	google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(28.450597, 77.040311), new google.maps.LatLng(28.430384, 77.040897));  
		
		
		 var testing = 	google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(28.43802519203148, 77.01255625550382), new google.maps.LatLng(28.42722553370286, 77.02915000166537));    

		 console.log(testing);
		

			this.plotStopPosition(this.alarmSummaryReverse);
		}
	};

	async Info_alarmModal_btn(id) {
		//$('#Info_alarmModal').modal('show');

		let area = await fetch(environment.apiUrl + 'vehicles/getAssignedArea' + '?VEHID=' + id, {
			method: 'get',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization: this.authtoken.token
			}
		});
		this.areaAssignment = await area.json();

		let staff = await fetch(environment.apiUrl + 'admin/getStaffAssignmentDetails' + '?VEHID=' + this.vehID, {
			method: 'get',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization: this.authtoken.token
			}
		});
		this.staffAssignment = await staff.json();
		this.driverName = this.staffAssignment[0].empname;
		this.driverMob = this.staffAssignment[0].MOBILENO;
		this.driverRole = this.staffAssignment[0].rolename;
		this.fetchWard = this.areaAssignment[0].wards;
		this.fetchZone = this.areaAssignment[0].zones;
	}

	getAlarmSummary() {
		$('#alarmSummary').modal('show');
		// this.alarmIMEI = sum.DEVICEID;
		this.singleVehSummary = this.alarmList.filter(
			(item) => item.IMEI == this.IMEI && item.alarmTypeId == this.alarmTypeId
		);

		this.totalAlarmGenerated = this.singleVehSummary.length;
		console.log('Filter Data', this.singleVehSummary);
		console.log('IMEI 2', this.IMEI);
	}

	printSummary(): void {
		let printContents, popupWin;
		printContents = document.getElementById('print-section').innerHTML;

		popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
		popupWin.document.open();
		popupWin.document.write(`
      <html>
        <head>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`);
		popupWin.document.close();
	}

	getUccPotential() {
		window.open(
			environment.apiUrl +
			'uccNew/getUCCPotentialReport?' +
			'prjId=' +
			this.prjID +
			'&fromDate=' +
			this.startDate +
			'&toDate=' +
			this.endDate
		);
	}

	onDateRangeChanged(dataRange) {
		if (dataRange.beginDate.day > 0) {
			this.startDate = dataRange.beginDate.year + '-' + dataRange.beginDate.month + '-' + dataRange.beginDate.day;
			this.endDate = dataRange.endDate.year + '-' + dataRange.endDate.month + '-' + dataRange.endDate.day;
			// this.getUccPotential();
		} else if (dataRange.beginDate.day == 0) {
			this.startDate = this.defaultStartDate;
			this.endDate = this.defaultStartDate;
			// this.getUccPotential();
		}
	}

	getPrevDayLocation = async (data) => {
		let res = await fetch(
			environment.apiUrl + 'vehicles/getPrevDayLocation' + '?DEVICEID=' + data.IMEI + '&prjId=' + this.prjID,
			{
				method: 'get',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization: this.authtoken.token
				}
			}
		);
		var lastActive = await res.json();
		if (lastActive.length > 0) {
			$('#alarmtable1').show();
			this.distance = 0;
			this.vehiclesNo = data.VEHNO;
			this.startTime = 'NA';
			this.endTime = 'NA';
			this.lastActiveTime = moment(new Date(lastActive[0].lastActiveDate)).startOf('hour').fromNow();
			var latlng = {
				lat: lastActive[0].lastLocation.coordinates[1],
				lng: lastActive[0].lastLocation.coordinates[0]
			};
			this.geocoder.geocode({ location: latlng }, (results, status) => {
				if (status === 'OK') {
					this.currentAddress = results[0].formatted_address;
				}
			});

			var start = new google.maps.LatLng(
				lastActive[0].lastLocation.coordinates[1],
				lastActive[0].lastLocation.coordinates[0]
			);
			this.markerStart = new google.maps.Marker({
				position: start,
				map: this.map,
				icon: 'assets/img/start.png',
				labelClass: 'labels', // the CSS class for the label
				labelStyle: { opacity: 1.0 }
			});
			var position = {
				LAT: lastActive[0].lastLocation.coordinates[1],
				LONG: lastActive[0].lastLocation.coordinates[0]
			};
			this.locateVehicle(position);
		}
	};

	closeAlarmInfo() {
		$('.individual_detail').slideToggle();
		$('#firstClick').toggleClass('arrowStyle');
	}
	getGeoLocation(lat, LONG, i, data) {
		var latlng = { lat: lat, lng: LONG };
		this.geocoder.geocode({ location: latlng, result_type: 'street_address' }, (results, status) => {
			if (status === 'OK') {
				var result = results[0].formatted_address;
				var address = result.split(',')[0] + ' ' + result.split(',')[1] + +' ' + result.split(',')[2];
				this.stopSummary[i].address = address;
			}
		});
	}

	diff_hours(dt2, dt1) {
		var difference = dt1.getTime() - dt2.getTime(); // This will give difference in milliseconds
		var resultInMinutes = Math.round(difference / 60000);
		var hours = resultInMinutes / 60;
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		return rhours + ': ' + rminutes;
	}

	diff_minutes(dt2, dt1) {
		var difference = dt1.getTime() - dt2.getTime(); // This will give difference in milliseconds
		var resultInMinutes = Math.round(difference / 60000);
		var hours = resultInMinutes / 60;
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		return rminutes;
	}

	plotStopPosition(stopInfo) {
		this.clearStopMarker();
		var data = { features: [], type: '' };
		data.type = 'FeatureCollection';
		var coordinates = [];
		var stop = 0;

		for (var i = 0; i < stopInfo.length; i++) {
			if (stopInfo[i].long && stopInfo[i].lat) {
				stop++;
				var geometry = { coordinates: [], type: '' };
				geometry.coordinates.push(Number(stopInfo[i].long), Number(stopInfo[i].lat));
				geometry.type = 'Point';
				var alarmTimeDate = this.datepipe.transform(stopInfo[i].alarmDate, 'dd-MM-yyyy hh:mm a');
				data.features.push({
					geometry: geometry,
					type: 'Feature',
					properties: {
						DEVICEID: stopInfo[i].DEVICEID,
						VEHICLE_NO: stopInfo[i].VEHICLE_NO,
						STARTTIME: stopInfo[i].STARTTIME,
						ENDTIME: stopInfo[i].ENDTIME,
						ZONE: stopInfo[i].zoneName,
						WARD: stopInfo[i].WardName,
						BEAT: stopInfo[i].beatName,
						VEHNO: stopInfo[i].VEHNO,
						IMEI: stopInfo[i].IMEI,
						ALARMTYPEID: stopInfo[i].alarmTypeId,
						DEVICEDATE: stopInfo[i].deviceDate,
						ALARMDATE: alarmTimeDate,
						ALARMTYPE: stopInfo[i].alarmType,
						TYPE: 'stopMarker',
						number: stop
					}
				});
			}
		}
		this.map.data.addGeoJson(data);
	}

	makeRoute(polyCords) {
		this.routePath = polyCords;
		var lineSymbol = {
			path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
			fillColor: '#121C11',
			offset: '2%'
		};
		this.route = new google.maps.Polyline({
			path: polyCords,
			strokeColor: '#121C11',
			strokeOpacity: 3.0,
			strokeWeight: 3,
			icons: [
				{
					icon: lineSymbol,
					offset: '100%'
				}
			],
			map: this.map
		});
	}
	createRouteChunk(coordinates) {
		this.multiRoute = [];
		var lineSymbol = {
			path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
			fillColor: '#D8E20F',
			offset: '2%'
		};
		var chunk_size = 10;
		var coords = [];
		var arrayLength = coordinates.length;
		for (var index = 0; index < arrayLength; index += chunk_size) {
			var myChunk = coordinates.slice(index, index + chunk_size);
			for (var i = 0; i < myChunk.length; i++) {
				coords.push({ lat: myChunk[i].LAT, lng: myChunk[i].LONG });
			}

			var route = new google.maps.Polyline({
				path: coords,
				strokeColor: '#121C11',
				strokeOpacity: 3.0,
				strokeWeight: 3,
				icons: [
					{
						icon: lineSymbol,
						offset: '100%'
					}
				],
				map: this.map
			});

			this.multiRoute.push(route);

			//this.makeRoute(coords);
			coords = [];
		}
		this.plotMultiRoute();
	}

	plotMultiRoute() {
		for (var i = 0; i < this.multiRoute.length; i++) {
			this.multiRoute[i].setMap(true);
		}
	}

	removeMultiRoute() {
		if (this.multiRoute.length > 0) {
			for (var i = 0; i < this.multiRoute.length; i++) {
				this.multiRoute[i].setMap(null);
			}
		}
	}

	plotRouteWhenLiveTrack() {
		this.route = new google.maps.Polyline({
			path: this.routePath,
			strokeColor: '#686C55',
			strokeOpacity: 1.0,
			strokeWeight: 3,
			map: this.map
		});
	}
	createRoute(map, pathCoords) {
		var i, route, marker;
		var polyCords = [];
		for (i = 0; i < pathCoords.length; i++) {
			polyCords.push({ lat: JSON.parse(pathCoords[i][1]), lng: JSON.parse(pathCoords[i][0]) });
		}
		console.log('Cords', polyCords);
		var car =
			'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z';
		var icon = {
			path: car,
			scale: 1,
			strokeColor: 'white',
			strokeWeight: 0.1,
			fillOpacity: 5,
			fillColor: '#35370C',
			offset: '2%',
			// rotation: parseInt(heading[i]),
			anchor: new google.maps.Point(10, 25) // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
		};
		this.routePath = polyCords;
		this.route = new google.maps.Polyline({
			path: polyCords,
			strokeColor: '#4baf4f',
			strokeOpacity: 4.0,
			strokeWeight: 5,
			icons: [
				{
					icon: icon,
					offset: '100%'
				}
			],
			map: map
		});
		this.zoomToObject(this.route);
	}

	clearCurrentVehicalInfo() {
		this.distance = null;
		this.vehiclesNo = null;
		this.IMEI = null;
		this.startTime = null;
		this.endTime = null;
		this.currentAddress = null;
	}
	vehiclelist() {
		$('.individual_box').show();
		$('#vehicleList').show();
		$('.alarmlistbox').show();
	}
	closeAlarmList() {
		$('.alarmlistbox').slideToggle();
		$('#secondClick').toggleClass('arrowStyle');
	}
	showCurrentVehiclesInfo(data, tableRow) {
		this.beatName = data.END_BEATNAME;
		this.distance = data.distance.toFixed(2);
		this.vehiclesNo = tableRow.VEHNO;
		this.alarmType = tableRow.alarmType;
		this.lastAlarmTime = tableRow.alarmDate;
		this.IMEI = tableRow.IMEI;
		this.alarmIMEI = data.DEVICEID;
		this.alarmRCNO = data.RCNO;
		this.startTime = moment(new Date(data.STARTTIME)).format('h:mm:ss a');
		this.endTime = moment(new Date(data.ENDTIME)).format('h:mm:ss a');
		this.lastActiveTime = tableRow.HEARTBEATDATE;
		var latlng = { lat: data.ENDPOINT.LAT, lng: data.ENDPOINT.LONG };
		this.geocoder.geocode({ location: latlng }, (results, status) => {
			if (status === 'OK') {
				this.currentAddress = results[0].formatted_address;
			}
		});

		var latlngStart = { lat: data.STARTPOINT.LAT, lng: data.STARTPOINT.LONG };

		this.geocoder.geocode({ location: latlngStart }, (results, status) => {
			if (status === 'OK') {
				this.currentAddressStart = results[0].formatted_address;
			}
		});
	}
	removeLine() {
		if (this.route) {
			this.route.setMap(null);
		}
	}
	removeMarker() {
		if (this.markerStart && this.markerEnd) {
			this.markerStart.setMap(null);
			this.markerEnd.setMap(null);
		} else if (this.markerStart) {
			this.markerStart.setMap(null);
		}
	}

	removeClickedMarker() {
		if (this.clickedMarker) {
			this.clickedMarker.setMap(null);
		}
	}
	removeStartAndEndPoint() {
		this.infoWindowStart.close();
		this.infoWindowEnd.close();
	}

	plotStartAndEndPoint(data) {
		var start = new google.maps.LatLng(data.STARTPOINT.LAT, data.STARTPOINT.LONG);
		var end = new google.maps.LatLng(data.ENDPOINT.LAT, data.ENDPOINT.LONG);
		this.markerStart = new google.maps.Marker({
			position: start,
			map: this.map,
			icon: 'assets/img/start.png',

			labelClass: 'labels', // the CSS class for the label
			labelStyle: { opacity: 1.0 }
		});
		this.markerEnd = new google.maps.Marker({
			position: end,
			map: this.map,
			icon: 'assets/img/end.png'
		});
	}

	removePolyLine(id) {
		for (var i = 0; i < this.polyline_array.length; i++) {
			if (id == this.polyline_array[i].id) {
				this.polyline_array[i].line.setMap(null);
			}
		}
	}

	animateLiveCircle(line) {
		var count = 0;
		var value = 300;
		stopAnimation = true;
		var myinterval = setInterval(() => {
			count = (count + 1) % 200;
			var icons = line.get('icons');
			icons[0].offset = count / 2 + '%';
			if (count === 199) {
				line.set('icons', null);
				clearInterval(myinterval);
				//line.unSet('icons', icons);
				line.setMap(null);
			}
			line.set('icons', icons);
		}, 250);
	}

	animateCircle(line) {
		var count = 0;
		$('#play').hide();
		$('#stop').show();
		if (!stopAnimation) {
			stopAnimation = true;
			return;
		}
		stopAnimation = true;
		var myVar = window.setInterval(function () {
			if (stopAnimation) {
				count = (count + 1) % 200;
				var icons = line.get('icons');
				icons[0].offset = count / 2 + '%';
				if (count === 199) {
					clearInterval(myVar);
					$('#play').show();
					$('#stop').hide();
				}
				line.set('icons', icons);
			}
		}, 150);
	}

	stopPlay() {
		stopAnimation = false;
		$('#play').show();
		$('#stop').hide();
	}
	zoomToObject(obj) {
		var bounds = new google.maps.LatLngBounds();
		var points = obj.getPath().getArray();
		for (var n = 0; n < points.length; n++) {
			bounds.extend(points[n]);
		}
		this.map.fitBounds(bounds);
	}

	clearFeature() {
		this.map.data.forEach((feature) => {
			this.map.data.remove(feature);
		});
	}
	removeMapLabel(entityId) {
		for (var i = 0; i < this.mapLabelArray.length; i++) {
			if (entityId == this.mapLabelArray[i].entityId) {
				this.mapLabelArray[i].setMap(null);
			}
		}
	}

	zoomOneEntity(this, map) {
		this.bounds = new google.maps.LatLngBounds();
		map.data.forEach((feature) => {
			if (feature.getProperty('type') == 'clickedPolygon') {
				this.processPoints(feature.getGeometry(), this.bounds.extend, this.bounds);
			}
		});
		map.fitBounds(this.bounds);

		this.map.data.setStyle(function (feature) {
			if (feature.getProperty('type') == 'clickedPolygon') {
				return {
					fillColor: '#666A06',
					strokeColor: '#066A0C',
					strokeWeight: 1,
					fillOpacity: 0.1,
					strokeopacity: 0.1
				};
			}
		});
	}

	clearPrevRoute(data) {
		this.map.data.forEach((feature) => {
			if (feature.getProperty('type') == 'route') {
				this.map.data.remove(feature);
			}
		});
	}

	clearStopMarker() {
		this.map.data.forEach((feature) => {
			if (feature.getProperty('TYPE') == 'stopMarker' || feature.getProperty('TYPE') == 'engine_Off') {
				this.map.data.remove(feature);
			}
		});
	}

	highLightAssignBeat(entityId) {
		this.map.data.setStyle(function (feature) {
			var color = feature.getProperty('FillColor');
			var strokeColor = feature.getProperty('Bcolor');
			if (feature.getProperty('TYPE') == 'stopMarker') {
				if (feature.getProperty('ALARMTYPEID') == 2) {
					var icon = 'assets/img/longHault.png';
				} else {
					var icon = 'assets/img/stopMarker.png';
				}
				return {
					fillColor: color,
					strokeColor: strokeColor,
					strokeWeight: 2,
					fillOpacity: 0.05,
					icon: icon,
					strokeopacity: 0.2,
					label: {
						text: feature.getProperty('number'),
						color: '#FFFFFF',
						fontSize: '13px',
						background: 'yellow',
						fontWeight: 'bold',
						AlignmentVertical: 'top',
						AlignmentHorizontal: 'center'
					},
					labelClass: 'my-custom-class-for-label'
				};
			} else if (
				feature.getProperty('Oemid') == 8 ||
				feature.getProperty('Oemid') == 9 ||
				feature.getProperty('Oemid') == 10 ||
				feature.getProperty('Oemid') == undefined
			) {
				return {
					fillColor: color,
					strokeColor: strokeColor,
					strokeWeight: 3,
					fillOpacity: 0.1,
					strokeopacity: 0.8
				};
			} else {
				return {
					fillColor: color,
					strokeColor: '#040C0A',
					strokeWeight: 4,
					fillOpacity: 0.1,
					strokeopacity: 0.4
				};
			}
		});
	}

	/* 
     excel Import
  */

	s2ab(s) {
		const buf = new ArrayBuffer(s.length);
		const view = new Uint8Array(buf);
		for (let i = 0; i !== s.length; ++i) {
			view[i] = s.charCodeAt(i) & 0xff;
		}
		return buf;
	}
	importToExcel(data) {
		const ws_name = 'SomeSheet';
		const wb: WorkBook = { SheetNames: [], Sheets: {} };
		const ws: any = utils.json_to_sheet(data);
		wb.SheetNames.push(ws_name);
		wb.Sheets[ws_name] = ws;
		const wbout = write(wb, {
			bookType: 'xlsx',
			bookSST: true,
			type: 'binary'
		});
		saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'AlarmDATA.xlsx');
	}

	locateVehicle(position) {
		var myPlace = new google.maps.LatLng(position.LAT, position.LONG);
		var bounds = new google.maps.LatLngBounds(myPlace);
		this.map.fitBounds(bounds);
	}

	polygonLabel(text, lat, long, strokeWeight, fontSize, entityId, color) {
		var myLatlng = new google.maps.LatLng(Number(lat), Number(long));
		var mapLabel = new MapLabel({
			text: text,
			position: myLatlng,
			map: this.map,
			strokeWeight: strokeWeight,
			fontSize: fontSize,
			align: 'left',
			entityId: entityId,
			fontColor: color
		});
		this.mapLabelArray.push(mapLabel);
		mapLabel.set('position', myLatlng);
	}

	statusColor() {
		console.log('fddsfs');

		return 'vehicle-box vts_installed_border';
	}

	closeMapInfo() {
		$('.map-info-window').hide();
	}
	ngOnInit() {
		this.getAlarm();
		this.getDelayed();
		$('#alarmtable1').hide();
		$('#Info_alarmModal').modal('hide');
		$('#alarmSummary').modal('hide');
		$('.map-info-window').hide();
		this.getAlarmCount();
		$('#loderImgTab').hide();
		this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
		this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');

		this.getDataWhenProjectChange(this.prjID);
		this.vehiclelist();
		var thisRef = this;
		$('#play').show();
		$('#stop').hide();
		$('#veichiclesInfo-bar').hide();
		$('#progress-bar').hide();
		var lastOpenedInfoWindow;
		this.geocoder = new google.maps.Geocoder();
		var myOptions = {
			center: new google.maps.LatLng(28.47769599987369, 77.06160699973178),
			zoom: 13,

			mapTypeControl: true,
			mapTypeControlOptions: {
				style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
				position: google.maps.ControlPosition.TOP_CENTER
			},
			zoomControl: true,
			zoomControlOptions: {
				position: google.maps.ControlPosition.CENTER_LEFT
			},
			scaleControl: true,
			fullscreenControl: true
		};
		this.map = new google.maps.Map(document.getElementById('map'), myOptions);

		var config = {
			authDomain: 'ecogreen-citizen-app.firebaseapp.com',
			apiKey: 'AIzaSyAHMkYkbjRTa9RazdKPJjtOJrdHCZVxxYg',
			databaseURL: 'HttpClient s://ecogreen-citizen-app-2ad05.firebaseio.com/',
			storageBucket: 'ecogreen-citizen-app.appspot.com',
			projectId: 'ecogreen-citizen-app'
		};

		var infoWindow = new google.maps.InfoWindow();
		this.map.data.addListener('click', showArrays);
		function showArrays(event) {
			closeLastOpenedInfoWindow();
			var position = { lat: event.latLng.lat(), lng: event.latLng.lng() };
			var content =
				"<div class='col-sm-12'>" +
				"<h5 style='font-weight:bold;font-size:20px;'>HOUSEHOLDS</h5>" +
				"<hr style='width:100%;margin:5px 0;border-color:#bbbbbb'>" +
				"<p class='info-deatil'><strong>Total HH:</strong><strong style='float:left;'>(W.I.P)</strong>" +
				'  ' +
				//alarmDetails.hh +
				"</p><p class='info-deatil'><strong>Potential:</strong><strong style='float:left;'>(W.I.P)</strong>" +
				'  ' +
				//alarmDetails.pot +
				"<hr style='width:100%;margin:5px 0;border-color:#bbbbbb'>" +
				// "</p><p class='info-deatil'><strong>Fixed Time:</strong><strong style='float:left;'>8:15 AM</strong>" +
				// '  ' +
				// //alarmDetails.fixed +
				"<p class='info-deatil'><strong>Alarm Time :</strong><strong style='float:left;'>" +
				'  ' +
				event.feature.getProperty('ALARMDATE') +
				//"</p><p class='info-deatil'><strong>Exit Time :</strong><strong style='float:left;'>11:33 AM</strong>" +
				// '  ' +
				// event.feature.getProperty('ENDTIME') +
				// "</p><p class='info-deatil'><strong>Ward :</strong>" +
				// '  ' +
				// event.feature.getProperty('WARD') +
				// ' ' +
				'</strong></p></div>';
			infoWindow = new google.maps.InfoWindow({
				content: content,
				position: position
			});

			google.maps.InfoWindowOptions;
			var marker = new google.maps.Marker({
				position: position,
				map: this.map,
				zoom: 16,
				visible: false
			});
			infoWindow.open(this.map);
			lastOpenedInfoWindow = infoWindow;
			/* Since this div is in a position prior to .gm-div style-iw.
       * We use jQuery and create a iwBackground variable,
       * and took advantage of the existing reference .gm-style-iw for the previous div with .prev().
      */
		}

		function closeLastOpenedInfoWindow() {
			if (lastOpenedInfoWindow) {
				lastOpenedInfoWindow.close();
			}
		}

		firebase.initializeApp(config);
		this.subscription = Observable.interval(2 * 60 * 1000).subscribe((x) => {
			thisRef.refreshCount(this.prjID)
		});
		// Observable.interval(60 * 1000).subscribe((x) => {
		// 	thisRef.refreshCount(this.prjID);
		// });
		var card = document.getElementById('pac-card');
		var input = document.getElementById('pac-input');

		thisRef.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);

		var autocomplete = new google.maps.places.Autocomplete(input);

		// Bind the map's bounds (viewport) property to the autocomplete object,
		// so that the autocomplete requests use the current map bounds for the
		// bounds option in the request.
		autocomplete.bindTo('bounds', thisRef.map);

		// Set the data fields to return when the user selects a place.
		autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);

		var infowindow = new google.maps.InfoWindow();
		var infowindowContent = document.getElementById('infowindow-content');
		infowindow.setContent(infowindowContent);
		var marker = new google.maps.Marker({
			map: thisRef.map,
			anchorPoint: new google.maps.Point(0, -29)
		});

		autocomplete.addListener('place_changed', function () {
			infowindow.close();
			marker.setVisible(false);
			var place = autocomplete.getPlace();
			if (!place.geometry) {
				// User entered the name of a Place that was not suggested and
				// pressed the Enter key, or the Place Details request failed.
				window.alert("No details available for input: '" + place.name + "'");
				return;
			}

			// If the place has a geometry, then present it on a map.
			if (place.geometry.viewport) {
				thisRef.map.fitBounds(place.geometry.viewport);
			} else {
				thisRef.map.setCenter(place.geometry.location);
				thisRef.map.setZoom(17); // Why 17? Because it looks good.
			}
			marker.setPosition(place.geometry.location);
			marker.setVisible(true);

			var address = '';
			if (place.address_components) {
				address = [
					(place.address_components[0] && place.address_components[0].short_name) || '',
					(place.address_components[1] && place.address_components[1].short_name) || '',
					(place.address_components[2] && place.address_components[2].short_name) || ''
				].join(' ');
			}

			infowindowContent.children['place-icon'].src = place.icon;
			infowindowContent.children['place-name'].textContent = place.name;
			infowindowContent.children['place-address'].textContent = address;
			infowindow.open(thisRef.map, marker);
		});

		//  drawing manager

		var drawingManager = new google.maps.drawing.DrawingManager({
			drawingControl: true,
			drawingControlOptions: {
				position: google.maps.ControlPosition.BOTTOM_CENTER,
				drawingModes: ['marker', 'polygon']
			},
			polygonOptions: {
				strokeWeight: 2,
				strokeColor: '#ff0000'
			}
		});
		drawingManager.setMap(this.map);
		google.maps.event.addListener(drawingManager, 'overlaycomplete', function (this, event) {
			// Get overlay paths
			var paths = event.overlay.getPaths();
			// Remove overlay from map
			event.overlay.setMap(null);
			// Disable drawingManager
			//drawingManager.setDrawingMode(null);
			thisRef.polygon = new google.maps.Polygon({
				fillColor: '#D4D9C8',
				fillOpacity: 0,
				strokeWeight: 3,
				strokeColor: '#7620A7',
				editable: true,
				paths: paths,
				map: this.map
			});
			var coordinatesArray = event.overlay.getPath();

			var testArray = [];
			for (var a = 0; a < coordinatesArray.length; a++) {
				var arr = [coordinatesArray.getAt(a).lng()];
				arr.push(coordinatesArray.getAt(a).lat());
				testArray.push(arr);
			}
			var arr1 = [coordinatesArray.getAt(0).lng()];
			arr1.push(coordinatesArray.getAt(0).lat());
			testArray.push(arr1);
		});

		// control
	}

	ngOnDestroy(){
		if (this.subscription){
			this.subscription.unsubscribe();
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/maptracker/vehicles/alarms.component.ts